<template>
  <div id="register">
    <PageHeader
      :pageHeader="pageHeader"
      :kvTitle1Color="kvTitle1Color"
      :kvTitle2Color="kvTitle2Color"
    />
    <router-view />
  </div>
</template>

<script>
import '@/assets/scss/register.scss';

import PageHeader from '@/components/PageHeader.vue';
import { RegisterKv } from '@/lib/const';

export default {
  title: '課程活動',
  name: 'RegisterHome',
  data() {
    return {
      ...RegisterKv,
      kvTitle1Color: 'txt-white',
      kvTitle2Color: 'txt-white',
    };
  },
  components: {
    PageHeader,
  },
};
</script>
